const WishlistCounter={

    update(items){

        document
        .querySelectorAll(".wishlist-count")
        .forEach(el=>{

            el.textContent=
            items.length || "";

        });

    }

};